<template>
  <section class="section aclaraciones-form">
    <div class="container">
      <b-field label="Aclaraciones">
        <b-input
          v-model="aclaraciones"
          type="textarea"
          rows="14"
          placeholder="Escriba una aclaración por línea"
        />
      </b-field>

      <p class="help mb-4">
        El texto se publica en la vista de cuotas y mínimos respetando los saltos de línea.
      </p>

      <b-button
        v-if="$hasPermission('cuotasyminimos.editar')"
        type="is-primary"
        :loading="saving"
        @click="save"
      >
        Guardar
      </b-button>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { alertSuccess, alertFailed } from "@/helpers";

export default {
  name: "FormAclaraciones",
  data() {
    return {
      aclaraciones: "",
      saving: false,
    };
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_ROOT_API}/api/general-settings/aclaraciones`)
      .then(({ data }) => {
        this.aclaraciones = data.value || "";
      })
      .catch(() => {
        alertFailed("No se pudieron cargar las aclaraciones");
      });
  },
  methods: {
    save() {
      this.saving = true;
      axios
        .post(`${process.env.VUE_APP_ROOT_API}/api/general-settings`, {
          key: "aclaraciones",
          value: this.aclaraciones,
        })
        .then(() => alertSuccess("Aclaraciones guardadas exitosamente"))
        .catch(() => alertFailed("No se pudieron guardar las aclaraciones"))
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
.aclaraciones-form {
  max-width: 900px;
}
</style>
